import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { firebaseConfig } from '../core/config/firebase.config';

let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  // Si l'app existe déjà, utiliser l'instance existante
  app = initializeApp(firebaseConfig, '[DEFAULT]');
}

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
